export class ApplicationSelection {
  constructor(
    public application: string,

    public environment: string) {

  }
}
